import { z } from 'zod';

export const supplierSchema = z.object({
  supplierId: z.string(),
  name: z.string(),
  contactName: z.string(),
  contactEmail: z.string(),
  contactPhone: z.string(),
  categories: z.array(z.string()),
  deliveryZones: z.array(z.string()),
  certifications: z.array(z.string()),
  rating: z.number(),
  onTimeDeliveryRate: z.number(),
  qualityScore: z.number(),
  totalOrders: z.number(),
  totalSpend: z.number(),
  isActive: z.boolean(),
  createdAt: z.string(),
});

export type Supplier = z.infer<typeof supplierSchema>;

export const suppliersResponseSchema = z.object({
  data: z.array(supplierSchema),
  pagination: z.object({
    nextToken: z.string().nullable(),
    totalCount: z.number() 
  }),
});

export type SuppliersResponse = z.infer<typeof suppliersResponseSchema>;
